export default __webpack_public_path__ + "static/media/swapBtn.e31bbb84.png";